export default {
  'order.CopiedSuccessfully': 'Copied successfully!',
  'order.ReplicationIsNotSupported': 'Replication is not supported',
  'order.YourApplicationHasBeenSuccessfulPleaseCheckTheOrderStatusLater':
    'Your application has been successful, please check the order status later',
  'order.TheSystemIsDeserted': 'The system is deserted!',
  'order.ParameterError': 'Parameter error!',
  'order.TransferToBePaid': 'Transfer to be paid',
  'order.OrderHasBeenTransferred': 'Order has been transferred',
  'order.SignUpAndPayNow': 'Sign up and pay now',
  'order.ApplyForADeduction': 'Apply for a deduction',
  'order.growBeans': 'grow beans',
  'order.MyShippingAddress': 'My shipping address',
  'order.LogisticsInformation': 'Logistics Information:',
  'order.openRecord': 'open record',
  'order.callOfficial': 'call official',
  'order.CheckRefund': 'Check Refund',
  'order.TotalEquityPayable': 'Total equity payable',
  'order.totalPrice': 'total price',
  'order.freight': 'freight',
  'order.AmountToBeCarriedForward': 'Amount to be carried forward',
  'order.transferFee': 'transfer fee',
  'order.TransferDiscount': 'Transfer discount',
  'order.FirstInstallmentDiscount': 'discount',
  'order.CompensationDiscounts': 'Compensation discounts',
  'order.DeductionInstructions': 'Deduction Instructions',
  'order.Payable': 'Payable:',
  'order.realPayment': 'real payment:',
  'order.toPay': 'to pay',
  'order.SubscriptionPay': 'Subscription pay',
  'order.PayForUpgrade': 'Pay for upgrade',
  'order.coupon': 'coupon',
  'order.orderNumber': 'order number',
  'order.copy': 'copy',
  'order.orderTime': 'order time',
  'order.paymentMethod': 'payment method',
  'order.PaymentTime': 'Payment time',
  'order.Ship': 'Ship',
  'order.deliveryTime': 'delivery time',
  'order.TransferOrderType': 'Transfer order type',
  'order.transferToYourself': 'transfer to yourself',
  'order.transferToOthers': 'transfer to others',
  'order.TransferOrderObject': 'Transfer order object',
  'order.TurnoverTime': 'Turnover time',
  'order.UpgradeInformation': 'Upgrade information',
  'order.hint': 'hint',
  'order.understood': 'understood',
  'order.ToPayForTheOrderPleasePayInTheOrderLogisticsOfTheCallOfficialAccount':
    'To pay for the order, please pay in the order logistics of the [Call] official account',
  'order.PleaseEnsureThatYourContractAccountBalanceIsSufficientBeforeMakingADeductionApplication':
    'Please ensure that your contract account balance is sufficient before making a deduction application',
  'order.Cancel': 'Cancel'
};
